import * as React from 'react';

interface SearchWarningProps {
  count: number;
  totalCount: number;
}

const SearchWarning: React.FC<SearchWarningProps> = (props) => {
  return (
    <div className="search-warning">
      <i className="fa-solid fa-circle-exclamation"></i>
      <span>
        Showing {props.count} of {props.totalCount} results.
        <br /> Try making the search term more specific.
      </span>
    </div>
  );
};

export default SearchWarning;
